export const dashboardConstants = {
  GETALL_REQUEST: 'STATS_GETALL_REQUEST',
  GETALL_SUCCESS: 'STATS_GETALL_SUCCESS',
  GETALL_FAILURE: 'STATS_GETALL_FAILURE',
};
